import { render, staticRenderFns } from "./login-account.vue?vue&type=template&id=130009be&scoped=true"
import script from "./login-account.vue?vue&type=script&lang=js"
export * from "./login-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130009be",
  null
  
)

export default component.exports